import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DropdownList from 'react-widgets/lib/DropdownList';

class DropdownField extends Component {
  static propTypes = {
    input: PropTypes.object,
    data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
    inputProps: PropTypes.object,
    meta: PropTypes.object,
    placeholder: PropTypes.string,
    error: PropTypes.string,
  };

  onChange = (e) => {
    this.props.input.onChange(e);
    this.props.input.onBlur(e);
  }

  onBlur = (e) => {
    if (!this.props.input.value) {
      const elem = this.props.data.find(el => el.name === e.target.value);
      this.props.input.onBlur(elem || null);
    }
  }

  render() {
    const { input, data, meta, inputProps, placeholder, error } = this.props;

    return (
      <DropdownList {...inputProps}
        data={data}
        filter="contains"
        className={(error && !meta.dirty && 'is-invalid')}
        defaultSearchTerm=""
        placeholder={placeholder}
        value={input.value}
        onBlur={this.onBlur}
        onChange={this.onChange}
      />
    );
  }
}

const wrapper = (props, error, componentProps) => (
  <DropdownField {...props} error={error} className={componentProps.className} />
);

export default wrapper;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/DropdownField.jsx